"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var CoachingList = /*#__PURE__*/function () {
  function CoachingList(client) {
    (0, _classCallCheck2["default"])(this, CoachingList);
    this.client = client;
    this.resourceUrl = '/admin';
  }

  (0, _createClass2["default"])(CoachingList, [{
    key: "coachesList",
    value: function coachesList(data) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.post("".concat(this.resourceUrl, "/coach-capacity"), data, args);
    }
  }, {
    key: "removeClient",
    value: function removeClient(clientId, coachId, data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
      }

      return this.client.post("".concat(this.resourceUrl, "/client/").concat(clientId, "/coach/").concat(coachId, "/remove-coach"), data, args);
    }
  }, {
    key: "assignClient",
    value: function assignClient(clientId, coachId, data) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        args[_key3 - 3] = arguments[_key3];
      }

      return this.client.post("".concat(this.resourceUrl, "/client/").concat(clientId, "/coach/").concat(coachId), data, args);
    }
  }, {
    key: "getCoachProfile",
    value: function getCoachProfile(coachId) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.get("/user/coach/".concat(coachId), args);
    }
  }, {
    key: "updateCoachProfile",
    value: function updateCoachProfile(data, coachId) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return this.client.put("/user/coach/".concat(coachId), data, args);
    }
  }]);
  return CoachingList;
}();

exports["default"] = CoachingList;